<template>
  <card shadow>
    <template #header>
      <div class="bg-white border-0">
        <div class="row align-items-center">
          <div class="col-8 text-start">
            <h5 class="mb-0">{{ $t("Filter by") }}</h5>
          </div>
          <!--              <div class="col-4 text-end">-->
          <!--                <base-button tag="a" :href="'/employees/'+$route.params.id+'/edit'" type="primary" class="btn btn-sm btn-primary">-->
          <!--                  Edit-->
          <!--                </base-button>-->
          <!--              </div>-->
        </div>
      </div>
    </template>

    <div class="row text-start">
      <div class="col-md-4">
        <div class="form-group has-label">
          <label class="form-label">{{ $t("Name") }}</label>
          <base-input
              v-model="filters.name"
              type="text"
              form-classes="input-group-alternative mb-2"
              :placeholder="$t('Name')"
              :error="v$.filters.name.$errors.map( err => { return err.$message })[0]"
          ></base-input>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group has-label">
          <label class="form-label">{{ $t("Phone number (with extension)") }}</label>
          <base-input
              v-model="filters.phoneNumber"
              type="text"
              form-classes="input-group-alternative mb-2"
              :placeholder="$t('e.g +35799112233')"
          ></base-input>
        </div>
      </div>
    </div>

    <template #footer>
      <div class="col float-end">
        <submit-button
            :alert-message="errorMessage"
            :state="loadingProcess"
            @clicked="getClients(true)"
>
          {{ $t("Search") }}
        </submit-button>
      </div>
    </template>
</card>
  <br>
  <div class="card shadow" :class="type === 'dark' ? 'bg-default' : ''">
    <div
      class="card-header border-0"
      :class="type === 'dark' ? 'bg-transparent' : ''"
    >
      <div class="row align-items-center">
        <div class="col">
          <h5 class="mb-0 text-start" :class="type === 'dark' ? 'text-white' : ''">
            {{ title }}
          </h5>
        </div>
        <div class="col text-end">
          <base-button tag="a" href="/clients/new" type="primary" size="sm">{{ $t("Add New") }}</base-button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <base-table
        class="table align-items-center table-flush text-start"
        :class="type === 'dark' ? 'table-dark' : ''"
        :thead-classes="type === 'dark' ? 'thead-dark' : 'thead-light'"
        tbody-classes="list"
        :data="tableData"
        :loading="loading"
        :paginated="true"
        :list-full="listFull"
        @fetch-more="fetchMore"
      >
        <template #columns>
          <th>{{ normalizeGreek($t("Name")) }}</th>
          <th>{{ normalizeGreek($t("Phone")) }}</th>
          <th>{{ normalizeGreek($t("City")) }}</th>
          <th>{{ normalizeGreek($t("Status")) }}</th>
          <th>{{ normalizeGreek($t("Date Created")) }}</th>
          <th></th>
        </template>

        <template #default="row">
<th scope="row">
            <div class="media align-items-center">
              <div class="media-body">
                <a :href="'/clients/' + row.item.id + '/info'">
                  <span class="name mb-0 text-sm fw-bolder">{{ row.item.firstName }} {{ row.item.lastName }}</span>
                </a>
              </div>
            </div>
          </th>
          <td>
            <div class="badge p-1 font-size-xs">
              <span class="text-black">{{ row.item.phoneNumber }}</span>
            </div>
          </td>
          <td>
             {{ $t(row.item.address?.city ?? "-") }}
          </td>
          <td>
            <div class="badge p-1 font-size-xs" :class="getStatusClass(row.item.status)">
              <span class="status">{{ $t(row.item.status ?? "") }}</span>
            </div>
          </td>
          <td>
            <div class="d-flex align-items-center">
              <!--              <span class="completion mr-2">{{ row.item.completion }}%</span>-->
              <!--              <div>-->
              <!--                <base-progress-->
              <!--                  :type="row.item.statusType"-->
              <!--                  :show-percentage="false"-->
              <!--                  class="pt-0"-->
              <!--                  :value="row.item.completion"-->
              <!--                />-->
              <!--              </div>-->
              <div class="name mb-0 text-md-left">{{ row.item.createdAt }}</div>
            </div>
          </td>

          <td class="text-end">
              <base-button
                tag="a"
                type="primary"
                :href="'/clients/' + row.item.id"
                class="border-0 me-2 text-white"
                size="md"
              >
              {{ $t("View") }}
            </base-button>
            <base-button
                size="md"
              type="danger"
              class="border-0"
              @click="deleteClient(row.item.id)"
            >
              Delete
            </base-button>
          </td>
        </template>
      </base-table>
    </div>

    <!--    <div-->
    <!--      class="card-footer d-flex justify-content-end"-->
    <!--      :class="type === 'dark' ? 'bg-transparent' : ''"-->
    <!--    >-->
    <!--      <base-pagination total="30"></base-pagination>-->
    <!--    </div>-->
  </div>
</template>
<script>
import {getStatusClass, normalizeGreek} from "@/helpers/common"
import BaseButton from "@/components/BaseButton.vue"
import FirebaseFunctionsHelper from "@/helpers/firebaseFunctionsHelper"
import BaseTable from "@/components/BaseTable.vue"
import SubmitButton from "@/components/SubmitButton.vue"
import BaseInput from "@/components/BaseInput.vue"
import Card from "@/components/Card.vue"
import {minLength} from "@vuelidate/validators"
import useVuelidate from "@vuelidate/core"

export default {
  name: "clients-table",
  components: {Card, BaseInput, SubmitButton, BaseTable, BaseButton},
  props: {
    type: {
      type: String,
    },
    title: String,
  },
  setup: () => ({ v$: useVuelidate() }),
  validations () {
    return {
      filters: {
        name: {
          minlength: minLength(3)
        },
      }
    }
  },
  data() {
    return {
      listFull: false,
      lastSnapshot: null,
      loadingProcess: "",
      errorMessage: "",
      filters: {
        phoneNumber: null,
        name: null
      },
      loading: true,
      tableData: [],
    }
  },
  async mounted() {
    await this.getClients()
  },
  methods: {
    normalizeGreek,
    deleteClient(id) {
      this.$swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete client!",
        confirmButtonColor: "#dc3545",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          let clientIndex = this.tableData.findIndex(e => e.id === id)
          if (clientIndex > -1){
            this.tableData.splice(clientIndex, 1)
          }
          FirebaseFunctionsHelper.callFunction("client-remove", {id: id})
              .then((result) => {
                console.log("res", result)
                // eslint-disable-next-line no-prototype-builtins
                if (result != null && result.hasOwnProperty("message")) {
                  console.log("resmessage", result.message)
                  this.loadingProcess = "failed"
                  this.errorMessage = result.message
                  this.$swal.fire({
                    icon: "error",
                    html: result.message,
                    title: "Something went wrong!",
                  })

                } else {
                  this.$swal.fire({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                    timerProgressBar: true,
                    icon: "success",
                    title: "Client deleted",
                    didOpen: (toast) => {
                      toast.addEventListener("mouseenter", this.$swal.stopTimer)
                      toast.addEventListener("mouseleave", this.$swal.resumeTimer)
                    }
                  })
                }

                this.getClients()
              }, this)
              .catch((error) => {
                console.error("submitUser error", error)
                this.$swal.fire({
                  icon: "error",
                  html: result.message,
                  title: "Something went wrong!",
                })
              })

        }
      })
    },
    getStatusClass,
    async fetchMore() {
      this.loading = true
      await this.getClients()
    },
    async getClients(clear = false) {
      // if (
      //   this.$store.state.system.companies.length > 0 &&
      //   this.$store.getters.isCacheExpired
      // ) {
      //   this.tableData = this.$store.state.system.companies
      //   return
      // }
      if (clear){
        this.tableData = []
        this.lastSnapshot = null
        this.listFull = false
      }

      await this.$store.dispatch("fetchPaginatedClients", {name: this.filters.name, phone: this.filters.phoneNumber, lastSnapshot: this.lastSnapshot}).then((result) => {
        this.loading = false

        if (result.data.length === 0){
          this.listFull = true
          return
        }

        result.data.forEach ( record => {

          let index = this.tableData.findIndex(r => r.id === record.id)
          if (index > -1){
            this.tableData[index] = record
          } else {
            this.tableData.push(record)
          }
        })

        if (result.lastSnapshot !== null){
          this.lastSnapshot = result.lastSnapshot
        }

        if (result.data === null || result.data.length < 10){
          this.listFull = true
        }
      })
    },
  },
}
</script>
<style></style>
